import React from 'react';
import { Box, Text } from 'grommet';

const ChartTooltip = ({ title, lines }) => (
    <Box background="background-front" border={{ color: 'border-weak' }} round="xsmall" pad="small" elevation="small">
        <Text size="small" color="text-weak">{title}</Text>
        {lines.map((line) => <Text key={line}>{line}</Text>)}
    </Box>
);

export default ChartTooltip;
